import {
  Bot, PenTool, Target, LineChart, Sparkles, Workflow,
  TrendingDown, CheckCircle2, Rocket, ShieldCheck, Users, Cpu
} from "lucide-react";

// Servido do próprio domínio (public/logo.png). Antes vinha do CDN de artefatos da
// Emergent, que é infra de scaffold e não da marca: se aquele bucket sumisse, o logo
// sumia do site inteiro (Navbar e Footer) sem nada no nosso repo denunciar.
export const LOGO = `${process.env.PUBLIC_URL || ""}/logo.png`;

export const BRAND = { name: "Biahflow" };

export const NAV = [
  { label: "Método", href: "#metodo" },
  { label: "Serviços", href: "#servicos" },
  { label: "Benefícios", href: "#beneficios" },
  { label: "Dúvidas", href: "#faq" }
];

export const HERO = {
  overline: "Agência Nativa de IA",
  lines: ["Fazemos Agentes", "de IA trabalharem", "por você."],
  subtitle:
    "Transformamos empresas tradicionais em empresas AI First — do diagnóstico e letramento à implementação de agentes que trabalham 24 horas por dia.",
  stats: [
    { value: "+48%", label: "de eficiência operacional" },
    { value: "24/7", label: "agentes sem pausa" },
    { value: "4", label: "pilares do método" }
  ]
};

export const MARQUEE = [
  "AI FIRST", "AGENTES DE IA", "AUTOMAÇÃO INTELIGENTE",
  "ESTRATÉGIA", "LETRAMENTO EM IA", "ESCALA"
];

export const PROBLEM = {
  overline: "O problema",
  title: "Para equipes sem IA, o problema é sempre o mesmo",
  body:
    "Seu time está sobrecarregado porque a empresa nunca foi estruturada com mentalidade AI First. O tempo não aumenta — mas a produtividade pode multiplicar.",
  pains: [
    "Tarefas repetitivas consumindo horas do seu time todos os dias",
    "Decisões tomadas no escuro, sem dados organizados",
    "Atendimento lento que faz clientes desistirem no meio do caminho",
    "Ferramentas de IA compradas, mas ninguém sabe usar de verdade"
  ]
};

export const SERVICES = {
  overline: "O que a IA faz por você",
  title: "Serviços inovadores para o crescimento",
  subtitle: "É muito mais que automação. É inteligência estratégica para cada setor do seu negócio.",
  items: [
    {
      icon: Bot,
      title: "Atendimento Inteligente",
      desc: "Chatbots e agentes que respondem clientes na hora, qualificam e encaminham — sem perder o tom da sua marca.",
      span: "md:col-span-7"
    },
    {
      icon: Target,
      title: "Geração de Leads",
      desc: "Pipelines que identificam, direcionam e atraem clientes de alta qualidade.",
      span: "md:col-span-5"
    },
    {
      icon: PenTool,
      title: "Criação de Conteúdo",
      desc: "Conteúdo envolvente e de alta qualidade, adaptado ao seu público com IA.",
      span: "md:col-span-5"
    },
    {
      icon: LineChart,
      title: "Insights baseados em Dados",
      desc: "Extraia insights de conjuntos de dados complexos para decisões estratégicas e análise preditiva.",
      span: "md:col-span-7"
    },
    {
      icon: Workflow,
      title: "Operações & Processos",
      desc: "Fluxos de backoffice automatizados de ponta a ponta.",
      span: "md:col-span-6"
    },
    {
      icon: Sparkles,
      title: "Consultoria em IA",
      desc: "Especialistas desenhando estratégias de IA sob medida para o seu negócio.",
      span: "md:col-span-6"
    }
  ]
};

export const METHOD = {
  overline: "Transformação AI First",
  title: "Os 4 pilares do Método Biahflow",
  subtitle: "Colocar Inteligência Artificial no centro do negócio exige método.",
  steps: [
    { n: "01", title: "Validar a estratégia", desc: "Diagnóstico profundo para entender onde a IA gera valor real e priorizar o que traz retorno mais rápido." },
    { n: "02", title: "Educar as equipes", desc: "Letramento em IA para que seu time entenda, confie e opere as novas ferramentas com autonomia." },
    { n: "03", title: "Desenvolver a solução", desc: "Construímos e testamos agentes e automações personalizados, com confiabilidade de alto nível." },
    { n: "04", title: "Escalar", desc: "Implantamos, monitoramos e evoluímos continuamente para multiplicar o impacto em toda a operação." }
  ]
};

export const BENEFITS = {
  overline: "Benefícios",
  title: "Maximize a eficiência, o impacto e ganhe tempo",
  subtitle: "Descubra os principais benefícios de ser nosso parceiro.",
  items: [
    { icon: TrendingDown, title: "Redução de Custos", desc: "Simplifique operações para minimizar custos e maximizar a eficiência geral do negócio." },
    { icon: CheckCircle2, title: "Melhores Resultados", desc: "Aproveite insights poderosos baseados em dados para alcançar resultados consistentes." },
    { icon: Rocket, title: "Maior Produtividade", desc: "Automatize tarefas redundantes e acelere as funções comerciais do seu time." }
  ]
};

export const DIFFERENTIALS = {
  overline: "Diferenciais",
  title: "Por que escolher a Biahflow?",
  body: "Não somos devs vendendo IA. Somos estrategistas que entendem de negócio, gente e tecnologia.",
  items: [
    { icon: ShieldCheck, title: "Estratégia antes do código", desc: "Cada agente nasce de um objetivo de negócio claro." },
    { icon: Users, title: "Foco em pessoas", desc: "Equipes letradas adotam a IA de verdade — e ficam." },
    { icon: Cpu, title: "Tecnologia de ponta", desc: "Modelos e ferramentas atuais, aplicados com responsabilidade." }
  ]
};

export const FAQ = [
  { q: "Preciso ter conhecimento técnico para começar?", a: "Não. Começamos com diagnóstico e letramento, guiando você e seu time em cada etapa. Cuidamos da parte técnica para você focar no negócio." },
  { q: "Quanto tempo leva para ver resultados?", a: "Os primeiros ganhos de produtividade costumam aparecer nas primeiras semanas após a implementação dos primeiros agentes, com evolução contínua a partir daí." },
  { q: "A IA vai substituir minha equipe?", a: "Não. A ideia é liberar seu time das tarefas repetitivas para que se dediquem ao que realmente exige criatividade e estratégia." },
  { q: "Como funciona o diagnóstico inicial?", a: "Mapeamos seus processos, identificamos onde a IA gera mais valor e desenhamos um plano priorizado por retorno — antes de escrever qualquer linha de código." }
];

export const FOOTER = {
  tagline: "Fazemos Agentes de IA trabalharem por você.",
  email: "oi@biahflow.ai",
  year: new Date().getFullYear()
};

export const COMPANY = {
  legalName: "Biahflow Ltda",
  taxId: "68.268.360/0001-02",
  address: {
    street: "Rua Visconde de Pirajá, 414 — Sala 718",
    district: "Ipanema",
    city: "Rio de Janeiro",
    state: "RJ",
    postalCode: "22410-002"
  }
};

// Ícone sem url NÃO renderiza (ver o filtro no Footer) — link social quebrado é pior
// que link ausente. Estas URLs estão replicadas em "sameAs" no JSON-LD de
// public/index.html: o HTML estático não lê este arquivo, então mudou aqui, mude lá.
export const SOCIAL = [
  { name: "Instagram", icon: "instagram", url: "https://instagram.com/biahflow" },
  { name: "Facebook", icon: "facebook", url: "https://facebook.com/biahflow" },
  { name: "LinkedIn", icon: "linkedin", url: "https://linkedin.com/company/biahflow" },
  { name: "YouTube", icon: "youtube", url: "https://youtube.com/@biahflow" },
  { name: "TikTok", icon: "tiktok", url: "https://tiktok.com/@biahflow" }
];
